const BRAND_SLOTS = ['primary', 'secondary', 'accent', 'background', 'text', 'dark'] as const;

export function isDisplayableCssColor(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed || /^var\(/i.test(trimmed)) return false;
  return /^#([0-9a-f]{3,8})$/i.test(trimmed) || /^rgba?\(/i.test(trimmed);
}

export function brandColorSwatches(
  brandColors: Record<string, string> | null | undefined
): Array<[string, string]> {
  if (!brandColors) return [];
  const fromSlots = BRAND_SLOTS.flatMap(slot => {
    const value = brandColors[slot];
    return value && isDisplayableCssColor(value)
      ? ([[slot, value]] as Array<[string, string]>)
      : [];
  });
  if (fromSlots.length > 0) return fromSlots;

  return Object.entries(brandColors)
    .filter(([, value]) => isDisplayableCssColor(value))
    .slice(0, 6);
}

export function colorDetected(value: string | undefined): boolean {
  return Boolean(value && isDisplayableCssColor(value));
}
